export default {"src":"/_next/static/media/recruitment.72f9bc12.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};